<div [style.font-size.px]="fontSize">
    <span class="example-pizza-party ">
    {{message}} <mat-icon class="material-icons">{{icon}}</mat-icon>
  </span>
</div>
